import { render, staticRenderFns } from "./HaAccommodations.vue?vue&type=template&id=35bf8c8e&scoped=true&"
import script from "./HaAccommodations.vue?vue&type=script&lang=js&"
export * from "./HaAccommodations.vue?vue&type=script&lang=js&"
import style0 from "./HaAccommodations.vue?vue&type=style&index=0&id=35bf8c8e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf8c8e",
  null
  
)

export default component.exports